<template>
  <div class="login__howto">
    <el-popover
      placement="top"
      width="360"
      trigger="click"
      content="親愛的老師您好，若您有需要登入老師專區，請先成為空英會員喔！並將您的姓名及會員帳號 (email) 通知負責貴校的教育服務專員，我們將會隨即為您提供服務。"
    >
      <el-button slot="reference" type="text" :disabled="loading">
        <i class="el-icon-question"></i>
        如何登入
      </el-button>
    </el-popover>
	<el-button slot="reference" type="text" :disabled="loading" 
      @click="forgot_pw">
      忘記密碼
    </el-button>
    <el-button
      type="text"
      :disabled="loading"
      @click="signup"
    >
      加入空英會員
    </el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      loading: 'loading/loading'
    })
  },
  methods: {
    signup () {
      let url = 'https://member.studioclassroom.com/signup.php'

      window.open(url, '_blank')
    },
    forgot_pw () {
      let url = 'https://member.studioclassroom.com/forgetpw.php'

      window.open(url, '_blank')
    }
  }
}
</script>
